<template>
  <div>
    <el-row>
      <el-col>
        <panel>
          <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">
              <el-col :span="24" >
                <el-form-item label="贷款编号：" style="width: 60%">
                  {{dataForm.rc__contractNo}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客户姓名：" prop="d__dealerName" style="width: 60%">
                  {{dataForm.rc__customerName}}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </panel>
        <panel :title="'第'+item.rcde__sequenceNo+'期（应还款日：'+ $moment(item.rcde__expectedRepayDate).format('YYYY-MM-DD')+'）'" border v-for="(item, idx) in dataForm.detail" :key="idx">
          <form-build :form-data="item" :form-columns="detailColumns"  labelWidth="250px" b></form-build>
        </panel>
        <div class="tr" style="padding-right:15px">减免金额：{{this.dataForm.freeAmount|formatMoney}}</div>
        <panel>
          上期余额：{{dataForm.rc__exBalanceAmount|formatMoney}}
        </panel>
        <panel :title="'网银流水'">
          <data-table
                      :table-data="{data: dataForm.txlist||[]}"
                      :columns="txlistColumns"
                      :is-pagination-show="false"
          />
        </panel>
        <span class="fwb"> 本期余额=</span> <span v-html="showformula1" class="fwb color-danger"></span><span v-html="showformula1__equal" class="fwb color-danger"></span>
        <panel>
          <data-table
            :table-data="{data: dataForm.chklist||[]}"
            :columns="chkColumns"
            :is-pagination-show="false"
          />
        </panel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import moment from 'moment'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {formatMoney} from "../../filters/CommonFilters";
    import PageContent from "../PageContent";
    export default {
        name: "InterestConfirmView",
      components: {PageContent},
      data(){
          return {
            showformula1:'',
            showformula1__equal:'',
            dataForm:{
              freeAmount:0,
            },
            dataFormRules:{},
            chkColumns:[
              {
                label: '节点',
                field: 'chk__checkPoint',
                formatter: function (r,c,v) {
                  return Status2CN(v)
                }
              },
              {
                label: '操作人',
                field: 'chk__operator',
              },
              {
                label: '操作时间',
                field: 'chk__operateTime',
                formatter: function (r,c,v) {
                  if(v)
                    return moment(v).format('YYYY-MM-DD HH:mm:ss')
                  else
                    return ''
                }
              },
            ],
            txlistColumns:[
              {
                label: '流水号',
                field: 'tx__bankRef',
              },
              {
                label: '日期',
                field: 'tx__txDate',
                formatter: function (r,c,v) {
                  if(v)
                    return moment(v).format('YYYY-MM-DD')
                  else
                    return ''
                }
              },

              {
                label: '备注',
                field: 'tx__txUse',
              },
              {
                label: '金额',
                field: 'tx__creditAmount',
                formatter: (r,c,v) => {
                  return formatMoney(Number(v)||0)
                }
              },
            ],
            detailColumns:[

              {
                label: '应收本金',
                field: 'rcde__expectedPrincipalAmount',
                formatter: (r,v) => {
                  return formatMoney(Number(v)||0)
                }
              },
              {
                label: '实收本金',
                field: 'rcde__appliedPrincipalAmount',
                formatter: (r,v) => {
                  return formatMoney(Number(v)||0)
                }
              },
              {
                label: '应收利息',
                field: 'rcde__expectedInterestAmount',
                formatter: (r,v) => {
                  return formatMoney(Number(v)||0)
                }
              },
              {
                label: '实收利息',
                field: 'rcde__appliedInterestAmount',
                formatter: (r,v) => {
                  return formatMoney(Number(v)||0)
                }
              },
              {
                label: '应收复利',
                field: 'rcde__expectedCompoundInterest',
                formatter: (r,v) => {
                  if(r.rcde__waiveCompoundInterest=='Y')
                    return formatMoney(Number(v)||0)+'(已减免)'
                  else
                    return formatMoney(Number(v)||0)
                }
              },
              {
                label: '实收复利',
                field: 'rcde__appliedCompoundInterest',
                formatter: (r,v) => {
                  return formatMoney(Number(v)||0)
                }
              },
              {
                label: '应收罚息',
                field: 'rcde__expectedOverdueFine',
                formatter: (r,v) => {
                  if(r.rcde__waiveOverdueFine=='Y')
                    return formatMoney(Number(v)||0)+'(已减免)'
                  else
                    return formatMoney(Number(v)||0)
                }
              },
              {
                label: '实收罚息',
                field: 'rcde__appliedOverdueFine',
                formatter: (r,v) => {
                  return formatMoney(Number(v)||0)
                }
              },
              {
                label: '应收合计',
                field: 'rcde__expectedRepayAmount',
                formatter: (r,v) => {
                  return formatMoney(Number(v)||0)
                }
              },
              {
                label: '实收合计',
                field: 'rcde__appliedRepayAmount',
                formatter: (r,v) => {
                  return formatMoney(Number(v)||0)
                }
              },
            ],
          }
      },
      props: {
        collectionId: {
          type: String
        }
      },
      watch: {
        collectionId: function(newVal) {
          if(newVal) {
            this.getData()
          }
        }
      },
      mounted() {
        if(this.collectionId) {
          this.getData()
        }
      },
      methods: {
        getData: function () {
          xhr.getRepaymentCollection({
              'rc.collectionId': this.collectionId
            },
            res => {
              try {
                if (res.data.status == 'success') {
                  this.dataForm = res.data.data
                  let amount = 0
                  this.showformula1 = ''
                  this.dataForm.txlist.forEach(item=>{
                    amount  = amount + item.tx__creditAmount
                    if(item.tx__creditAmount>0){}
                    if( this.showformula1)
                      this.showformula1 = this.showformula1+'+'+formatMoney(item.tx__creditAmount)
                    else
                      this.showformula1 = formatMoney(item.tx__creditAmount)
                    }
                  )
                  let freeAmount = 0
                  let allAmount = 0
                  this.dataForm.detail.forEach(item=>{
                    if(item.rcde__waiveCompoundInterest=='Y'){
                      freeAmount = freeAmount +item.rcde__expectedCompoundInterest
                    }else{
                      allAmount = allAmount +parseFloat(item.rcde__expectedCompoundInterest)*100
                    }
                    if(item.rcde__waiveOverdueFine=='Y'){
                      freeAmount = freeAmount +item.rcde__expectedOverdueFine
                    }else{
                      allAmount = allAmount +parseFloat(item.rcde__expectedOverdueFine)*100
                    }
                    this.dataForm.freeAmount = freeAmount
                      allAmount = allAmount + parseFloat(item.rcde__appliedPrincipalAmount)*100 +parseFloat(item.rcde__appliedInterestAmount)*100
                  }
                  )
                  this.dataForm.txlist.push(
                    {
                      tx__bankRef:'合计',
                      tx__creditAmount:amount,
                    }
                  )
                  if(allAmount>0){
                    this.showformula1 = this.showformula1+'-'+formatMoney(allAmount/100)
                  }


                  this.showformula1__equal =  formatMoney(this.dataForm.rc__exBalanceAmount)

                  if(this.showformula1.indexOf('+')>-1||this.showformula1.indexOf('-')>-1){
                    this.showformula1__equal = '='+this.showformula1__equal
                  }else{
                    this.showformula1__equal = ''
                  }
                }
              } catch (e) {

              }
            })
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/InterestConfirmView.vue